import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const apiHeaders = {
    'X-BingApis-SDK': 'true',
    'X-RapidAPI-Host': 'bing-news-search1.p.rapidapi.com',
    'X-RapidAPI-Key': 'ea67e768dfmsh709f4f9b7852f31p1a68f6jsneed4a79d3c41',
}


const baseQuery = fetchBaseQuery({ 
    baseUrl: 'https://bing-news-search1.p.rapidapi.com',
  })

const createRequest = (url) => ({ url, headers: apiHeaders});

export const bingApi = createApi({
    reducerPath: 'bingApi',
    baseQuery,
    endpoints: (builder) => ({
        getCryptoNews: builder.query({
            query: ({newsCategory, count}) => createRequest(`/news/search?=${newsCategory}&safeSearch=Off&textFormat=Raw&&freshness=Day&count=${count}`)
        }),
        
    })
});

export const {
    useGetCryptoNewsQuery,
} = bingApi;